import {
  Box,
  FormControl,
  InputLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React, { useContext, useState } from 'react';
import InstitutionContext from '../../../../shared-components/contexts/InstitutionContext';
import { FollowingType, TermType } from '../../Types/StudentFilterTypes';

interface IStudentFilterPopoverContent {
  followingFilter: FollowingType;
  termFilter: TermType;
  onApply: (followingFilter: FollowingType, termFilter: TermType) => void;
  onClose: () => void;
}

const useStyles = makeStyles(theme => ({
  radioFormControls: {
    padding: '8px 0 2px 8px',
    border: '1px solid #c4c4c4',
    borderRadius: '4px',
  },
  radioFormControlLabel: {
    transform: 'translate(14px, -6px) scale(0.75)',
    background: '#FFF',
    fontSize: '1rem',
    fontWeight: 400,
    marginLeft: '-5px',
    borderLeft: '4px solid #FFF',
    borderRight: '4px solid #FFF',
  },
  radioButton: {
    padding: '9px 3px 9px 9px',
  },
  radioLabel: {
    marginRight: '30px',
  },
}));

const StudentFilterPopoverContent = (props: IStudentFilterPopoverContent) => {
  const classes = useStyles();
  const institution = useContext(InstitutionContext);

  const [followingFilter, setFollowingFilter] = useState(props.followingFilter);
  const [termFilter, setTermFilter] = useState(props.termFilter);

  return (
    <>
      <Box style={{ marginBottom: '10px' }}>
        <FormControl
          variant="outlined"
          className={classes.radioFormControls}
          style={{ width: '100%', marginTop: '10px' }}
        >
          <InputLabel
            id="students-select-label"
            className={classes.radioFormControlLabel}
            disableAnimation
          >
            Students
          </InputLabel>
          <RadioGroup
            value={followingFilter}
            onChange={e => setFollowingFilter(e.target.value as FollowingType)}
            row
          >
            <FormControlLabel
              value="all"
              control={
                <Radio
                  value="all"
                  color="primary"
                  className={classes.radioButton}
                />
              }
              label="All"
              className={classes.radioLabel}
            />
            <FormControlLabel
              value="following"
              control={
                <Radio
                  value="following"
                  color="primary"
                  className={classes.radioButton}
                />
              }
              label="Following"
              className={classes.radioLabel}
            />
          </RadioGroup>
        </FormControl>
        {institution.settings.hasTerms && (
          <FormControl
            variant="outlined"
            className={classes.radioFormControls}
            style={{ width: '100%', marginTop: '10px' }}
          >
            <InputLabel
              id="term-select-label"
              className={classes.radioFormControlLabel}
              disableAnimation
            >
              Alerts From
            </InputLabel>
            <RadioGroup
              value={termFilter}
              onChange={e => setTermFilter(e.target.value as TermType)}
              row
            >
              <FormControlLabel
                value="all"
                control={
                  <Radio
                    value="all"
                    color="primary"
                    className={classes.radioButton}
                  />
                }
                label="All Terms"
                className={classes.radioLabel}
              />
              <FormControlLabel
                value="current"
                control={
                  <Radio
                    value="current"
                    color="primary"
                    className={classes.radioButton}
                  />
                }
                label="Current Term"
                className={classes.radioLabel}
              />
            </RadioGroup>
          </FormControl>
        )}
      </Box>

      <Box display="flex">
        <Box sx={{ flexGrow: 1 }}>
          <Button
            variant="outlined"
            onClick={() => {
              props.onApply('all', 'all');
              props.onClose();
            }}
          >
            Reset Filters
          </Button>
        </Box>

        <Box>
          <Button
            variant="text"
            color="primary"
            onClick={() => {
              props.onClose();
            }}
            style={{ marginRight: '5px' }}
          >
            Cancel
          </Button>

          <Button
            color="primary"
            onClick={() => {
              props.onApply(followingFilter, termFilter);
              props.onClose();
            }}
          >
            Apply
          </Button>
        </Box>
      </Box>
    </>
  );
};
export default StudentFilterPopoverContent;
